import { useParams } from 'react-router-dom';
import { useGetDatasetQuery } from '~/api/v2/hooks';
import { useFullName } from '~/hooks';
import { DetailsDataConfig, UsersNetworkIdsPanel } from '~/pages/DatasetDetailsPage/components/types';

const useUsersDataConfig = () => {
  const datasetId = +useParams().id!;
  const { data } = useGetDatasetQuery({ datasetId });
  const { fullName, isFetching } = useFullName();

  const getUsersAndNetworkIds = (userType: UsersNetworkIdsPanel) => {
    const config = {
      [UsersNetworkIdsPanel.SECONDARY_DATA_STEWARDS]: {
        users: data?.secondary_data_owners,
        usersNetworkIds: data?.secondary_data_owner_network_ids,
        label: 'secondary data steward',
        networkIdLabel: 'secondary data steward network id',
      },
      [UsersNetworkIdsPanel.DATA_UPLOADERS]: {
        users: data?.data_uploaders,
        usersNetworkIds: data?.data_uploaders_network_ids,
        label: 'data uploader',
        networkIdLabel: 'data uploader network id',
      },
    };

    const { users, usersNetworkIds, label, networkIdLabel } = config[userType];
    if (!users || !usersNetworkIds || isFetching) return [];

    return users
      .flatMap((userId, index) => {
        const userFullName = fullName(userId);
        if (!userFullName) return null;

        return [
          {
            key: `${label}${userFullName}`,
            label,
            value: userFullName,
          },
          {
            key: `${networkIdLabel}${usersNetworkIds[index]}${userFullName}`,
            label: networkIdLabel,
            value: usersNetworkIds[index],
          },
        ];
      })
      .filter(Boolean) as { label: string; value: string }[];
  };

  const stewardsDataConfig: DetailsDataConfig[] = [
    {
      label: 'primary data steward',
      value: fullName(data?.data_owner_name),
    },
    {
      label: 'primary data steward network id',
      value: data?.data_owner_network_id,
    },
    ...getUsersAndNetworkIds(UsersNetworkIdsPanel.SECONDARY_DATA_STEWARDS),
  ];

  const uploadersDataConfig: DetailsDataConfig[] = getUsersAndNetworkIds(UsersNetworkIdsPanel.DATA_UPLOADERS);

  return { stewardsDataConfig, uploadersDataConfig };
};

export default useUsersDataConfig;
